import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid'; // Make sure to install uuid
import { createCollectionData , getCollectionData } from '../../util/api';



// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/TransactionPage/SET_INITIAL_VALUES';

export const FETCH_TRANSACTION_REQUEST = 'app/InvitationPage/FETCH_TRANSACTION_REQUEST';
export const FETCH_TRANSACTION_SUCCESS = 'app/InvitationPage/FETCH_TRANSACTION_SUCCESS';
export const FETCH_TRANSACTION_ERROR = 'app/InvitationPage/FETCH_TRANSACTION_ERROR';


export const USER_EXISTS_REQUEST = 'app/InvitationPage/USER_EXISTS_REQUEST';
export const USER_EXISTS_SUCCESS = 'app/InvitationPage/USER_EXISTS_SUCCESS';
export const USER_EXISTS_ERROR = 'app/InvitationPage/USER_EXISTS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchTransactionInProgress: false,
  fetchTransactionError: null,
  transactionRef: null,
  transitionInProgress: null,
  transitionError: null,
  fetchMessagesInProgress: false,
  fetchMessagesError: null,
  totalMessages: 0,
  totalMessagePages: 0,
  oldestMessagePageFetched: 0,
  messages: [],
  initialMessageFailedToTransaction: null,
  savePaymentMethodFailed: false,
  sendMessageInProgress: false,
  sendMessageError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  monthlyTimeSlots: {
    // Example format:
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  fetchTransitionsInProgress: false,
  fetchTransitionsError: null,
  processTransitions: null,
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  alreadyExistsInprogress:false,
  alreadyExistsError:null
};

// Merge entity arrays using ids, so that conflicting items in newer array (b) overwrite old values (a).
// const a = [{ id: { uuid: 1 } }, { id: { uuid: 3 } }];
// const b = [{ id: { uuid: 2 } }, { id: { uuid: 1 } }];
// mergeEntityArrays(a, b)
// => [{ id: { uuid: 3 } }, { id: { uuid: 2 } }, { id: { uuid: 1 } }]


export default function transactionPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TRANSACTION_REQUEST:
      return { ...state, fetchTransactionInProgress: true, fetchTransactionError: null };

    case FETCH_TRANSACTION_SUCCESS: {
      const transactionRef = { id: payload.data?.data?.id, type: 'transaction' };
      return { ...state, fetchTransactionInProgress: false, transactionRef };
    }

    case FETCH_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchTransactionInProgress: false, fetchTransactionError: payload };

      case USER_EXISTS_REQUEST:
        return { ...state, alreadyExistsInprogress: true, alreadyExistsError: null };
  
      case USER_EXISTS_SUCCESS: {
        return { ...state, alreadyExistsInprogress: false , payload};
      }
  
      case USER_EXISTS_ERROR:
        console.error(payload); // eslint-disable-line
        return { ...state, alreadyExistsInprogress: false, alreadyExistsError: payload }; 

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const transitionInProgress = state => state.TransactionPage.transitionInProgress;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const fetchTransactionRequest = () => ({ type: FETCH_TRANSACTION_REQUEST });

const fetchTransactionSuccess = response => ({
  type: FETCH_TRANSACTION_SUCCESS,
  payload: response,
});

const fetchTransactionError = e => ({
  type: FETCH_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

const alreadyExistsRequest = () => ({ type:  USER_EXISTS_REQUEST});

const alreadyExistsSuccess = response => ({
  type: USER_EXISTS_SUCCESS,
  payload: response,
});

const alreadyExistsError = e => ({
  type: USER_EXISTS_ERROR,
  error: true,
  payload: e,
});



// ================ Thunks ================ //


export const applyInvitation = ({ values }) => (dispatch) => {
  dispatch(fetchTransactionRequest());

  const { email, fname, lname, residence, join } = values.values;
  const { verificationCode, inviterId, inviterName, baseURL } = values;
  const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

  const payload = {
    firstName: fname,
    lastName: lname,
    email: email,
    country: residence,
    reason: join,
    inviterId,
    verificationCode,
    inviterName,
    isUsed: false,
    expiresAt,
    createdAt: new Date(),
    status: "pending",
    url: baseURL
  };

  return createCollectionData({ payload })
    .then((response) => {
      dispatch(fetchTransactionSuccess(response));
      console.log('Invitation created successfully');
      return response;
    })
    .catch((error) => {
      console.error('Error applying invitation:', error);
      dispatch(fetchTransactionError(error));
    });
};

export const alreadyExists = (values) => (dispatch) => {
  dispatch(alreadyExistsRequest());
  const { email } = values.values;
  const query = { email };
  const options = { limit: 1 };

  return getCollectionData({
    tableName: "Invitation_Data",
    query,
    options,
    fnCallback: false,
  })
    .then((response) => {
      dispatch(alreadyExistsSuccess(response));
      return response.data[0] || [];
    })
    .catch((error) => {
      console.error("Error checking email:", error);
      dispatch(alreadyExistsError(error));
    });
};


export const loadData = (params, search, config) => (dispatch, getState) => {
  // In case a transaction reference is found from a previous
  // data load -> clear the state. Otherwise keep the non-null
  // and non-empty values which may have been set from a previous page.
  const initialValues = {}


  // Sale / order (i.e. transaction entity in API)
  return Promise.all([
    dispatch(setInitialValues(initialValues))
  ]);
};
